import * as $ from 'jquery';

export class ContactMap {
   constructor() {
      this.$block = $('#contact-block');

      if (this.$block.length === 0) return false;

      this.$mapNav = this.$block.find('.map-nav');
      this.$map = $('#contact-map');

      this.mapData = JSON.parse(this.$block.attr('data-points'));

      this.$gmarkersArray = [];

      this.isFirst = true;

      this.marketLogo = {};

      this.init();
   }

   init = () => {
      this.initMap().then(map => this.map = map);
    /*  this.initMap();
      this.initStartView();
      this.mapFilter();
      this.initHandlers();*/

   };

   initMap() {
      return new Promise(resolve => {
         ymaps.ready(() => {
            const map = new ymaps.Map('contact-map', {
               center: [53.197617, 50.128651],
               controls: [],
               zoom: 14
            }, {
               suppressMapOpenBlock: true,
               yandexMapDisablePoiInteractivity: true
            });

            map.behaviors.disable('scrollZoom');
            map.behaviors.disable('dblClickZoom');
            map.behaviors.disable('multiTouch');


            $(window).on('resize', function() {
               map.container.fitToViewport();
            });

            const balloonLayout = ymaps.templateLayoutFactory.createClass(
                `<div class="popup-huyap">г. Самара, ул. Чкалова, 100п,
                  3 этаж, офис 326 <i class="close icon-cancel"></i></div> `
            )

            this.marketLogo = new ymaps.Placemark([53.197617,50.128651],{
            },{
               iconLayout: 'default#image',
               iconImageHref: '../img/svg/placemark.svg',
               iconImageSize: [44, 47],
               balloonLayout: balloonLayout
            });

            map.geoObjects.add(this.marketLogo);

            this.$gmarkersArray = [...this.$gmarkersArray, this.marketLogo];

            $('body').on('click', '.popup-huyap .close', (e) => {
               this.marketLogo.balloon.close();
            })

            resolve(map);
         });
      })
   }

   /*initHandlers = () => {
      this.$mapNav.find('button').on('click', e => {
         e.preventDefault();

         const activeLength = $(e.currentTarget).siblings('button.active').length;

         if ($(e.currentTarget).hasClass('active')) {
            if (activeLength) {
               $(e.currentTarget).siblings('button').removeClass('active');

            } else {
               $(e.currentTarget).siblings('button').addClass('active');
            }
         } else {
            $(e.currentTarget).toggleClass('active');
         }

         this.mapFilter();
      });
   };

   initMap = () => {
      this.$map = new google.maps.Map(document.getElementById('contact-map'), {
         center: {
            lat: 53.197617,
            lng: 50.128651
         },
         zoom: 16,
         zoomControl: false,
         mapTypeControl: false,
         scaleControl: false,
         streetViewControl: false,
         rotateControl: false,
         fullscreenControl: false,
         styles: [
            {
               "featureType": "administrative",
               "elementType": "labels",
               "stylers": [
                  {
                     "visibility": "off"
                  }]
            },
            {
               "featureType": "administrative",
               "elementType": "labels.text.fill",
               "stylers": [
                  {
                     "color": "#ff0000"
                  },
                  {
                     "visibility": "off"
                  }]
            },
            {
               "featureType": "administrative.province",
               "elementType": "geometry.fill",
               "stylers": [
                  {
                     "visibility": "on"
                  }]
            },
            {
               "featureType": "landscape",
               "elementType": "all",
               "stylers": [
                  {
                     "color": "#f2f2f2"
                  }]
            },
            {
               "featureType": "landscape",
               "elementType": "geometry.fill",
               "stylers": [
                  {
                     "color": "#edf1f3"
                  }]
            },
            {
               "featureType": "landscape.natural.landcover",
               "elementType": "geometry.fill",
               "stylers": [
                  {
                     "visibility": "on"
                  }]
            },
            {
               "featureType": "poi",
               "elementType": "all",
               "stylers": [
                  {
                     "visibility": "off"
                  }]
            },
            {
               "featureType": "road",
               "elementType": "all",
               "stylers": [
                  {
                     "saturation": -100
                  },
                  {
                     "lightness": 45
                  }]
            },
            {
               "featureType": "road",
               "elementType": "labels.text.fill",
               "stylers": [
                  {
                     "color": "#073b58"
                  }]
            },
            {
               "featureType": "road.highway",
               "elementType": "all",
               "stylers": [
                  {
                     "visibility": "simplified"
                  }]
            },
            {
               "featureType": "road.arterial",
               "elementType": "labels.icon",
               "stylers": [
                  {
                     "visibility": "off"
                  }]
            },
            {
               "featureType": "transit",
               "elementType": "all",
               "stylers": [
                  {
                     "visibility": "off"
                  }]
            },
            {
               "featureType": "water",
               "elementType": "all",
               "stylers": [
                  {
                     "color": "#d1e3ea"
                  },
                  {
                     "visibility": "on"
                  }]
            },
            {
               "featureType": "water",
               "elementType": "geometry.fill",
               "stylers": [
                  {
                     "color": "#d6dfe3"
                  }]
            }
         ]

      });

      this.marketLogo = new google.maps.Marker({
         position: {
            lat: 53.197617,
            lng: 50.128651
         },
         map: this.$map,
         category: 'all',
         icon: {
            url: '../img/svg/placemark.svg',
            scaledSize: new google.maps.Size(44, 47)
         }
      });

      this.$gmarkersArray = [...this.$gmarkersArray, this.marketLogo];



   };

   initStartView = () => {
      let data = this.mapData.types;
      let activeInfoWindow;
      for (let key in data) {
         let type = key;

         if (data[key]) {
            for (let j = 0; j < data[key].length; j++) {
               let point = data[key][j];
               let coords = point.coords.split(',');

               const infowindow = new google.maps.InfoWindow({
                  content: `<div class="popup-huyap">${point.label}</div>`,
               });

               const mainWindow = new google.maps.InfoWindow({
                  content: `<div class="popup-huyap">г. Самара, ул. Чкалова, 100п,
                  3 этаж, офис 326</div>`,
               });

               this.marketLogo.addListener("click", () => {
                  if (activeInfoWindow) { activeInfoWindow.close(); }
                  mainWindow.open({
                     anchor: this.marketLogo,
                     shouldFocus: false,
                  });

                  activeInfoWindow = mainWindow;
               });


               let marker = new google.maps.Marker({
                  position: {
                     lat: +coords[0],
                     lng: +coords[1]
                  },
                  map: this.$map,
                  category: type,
                  icon: {
                     url: '../img/svg/' + type + '.svg',
                     scaledSize: new google.maps.Size(30, 30)
                  },
               });

               marker.addListener("click", () => {
                  if (activeInfoWindow) { activeInfoWindow.close(); }
                  infowindow.open({
                     anchor: marker,
                     shouldFocus: false,
                  });

                  activeInfoWindow = infowindow;
               });


               this.$gmarkersArray = [...this.$gmarkersArray, marker];
            }
         }
      }
   };

   mapFilter = () => {
      let categories = this.$mapNav
         .find('button.active');

      const catArr = [];

      categories.each((key, item) => {
         const category = $(item).attr('data-category');
         catArr.push(category)
      });

      let bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.$gmarkersArray.length; i++) {
         let marker = this.$gmarkersArray[i];

         if (catArr.includes(marker.category) || marker.category === 'all') {
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
         } else {
            marker.setVisible(false);
         }
      }
   };*/
}